import axios from "../../../apis/Api";
import history, { logout } from "../../../history";
import { toast } from "react-toastify";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import { GET_LOAN_REPAYMENT_REPORT } from "../../../Types";
import fileSaver from "file-saver";
import * as XLSX from "xlsx";

export const getLoanRepaymentReport = (requestData) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/LendingReports/GetLoanRepaymentReport`, requestData)
    .then(({ data }) => {
      if (data)
        dispatch({
          type: GET_LOAN_REPAYMENT_REPORT,
          payload: data,
        });
      dispatch(hideLoading());
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      }
    });
};

export const downloadJob = (requestData) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/LendingReports/GetLoanRepaymentReport`, requestData)
    .then(({ data }) => {
      const outputFilename = `LOAN_REPAYMENT_REPORT_${Date.now()}`;
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";

      const exportToCSV = (csvData, jobNumber, fileName, columnsToKeep) => {
        const filteredData = csvData.map(row => {
          return Object.keys(row)
            .filter(key => columnsToKeep.includes(key))
            .reduce((obj, key) => {
              obj[key] = row[key];
              return obj;
            }, {});
        });

        const ws = XLSX.utils.json_to_sheet(filteredData);
        if (ws) {
          var range = XLSX.utils.decode_range(ws["!ref"]);
          for (var C = range.s.c; C <= range.e.c; ++C) {
            var address = XLSX.utils.encode_col(C) + "1";
            if (!ws[address]) continue;
            ws[address].v =
              ws[address].v == "distributor"
                ? "Distributor"
                : ws[address].v == "distCenter"
                  ? "Dist Center"
                  : ws[address].v == "vizShopCode"
                    ? "VIZ ID"
                    : ws[address].v == "distShopCode"
                      ? "Shop Code"
                      : ws[address].v == "shopName"
                        ? "Shop Name"
                        : ws[address].v == "cnicNo"
                          ? "CNIC No"
                          : ws[address].v == "mobileNumber"
                            ? "Mobile Number"
                            : ws[address].v == "financier"
                              ? "Financier"
                              : ws[address].v == "invoiceNumber"
                                ? "Invoice Number"
                                : ws[address].v == "invoiceAmount"
                                  ? "Invoice Amount"
                                  : ws[address].v == "financeAmount"
                                    ? "Finance Amount"
                                    : ws[address].v == "repaidAmount"
                                      ? "Repaid Amount"
                                      : ws[address].v == "outstandingAmount"
                                        ? "Outstanding Amount"
                                        : ws[address].v == "paidThrough"
                                          ? "Paid Through"
                                          : ws[address].v == "financeStatus"
                                            ? "Finance Status"
                                            : ws[address].v == "invoiceDateStr"
                                              ? "Invoice Date"
                                              : ws[address].v == "financeId"
                                                ? "finance Id"
                                                : ws[address].v == "financeDateStr"
                                                  ? "Finance Date"
                                                  : ws[address].v == "profitAmount"
                                                    ? "Profit Amount"
                                                    : ws[address].v == "totalPayable"
                                                      ? "Total Payable"
                                                      : ws[address].v == "repaymentDateStr"
                                                        ? "Repayment Date"
                                                        : ws[address].v == "tid"
                                                          ? "TID"
                                                          : ws[address].v == "tillNo"
                                                            ? "Till No"
                                                            : ws[address].v == "distShopName"
                                                              ? "Shop Name"
                                                              : ws[address].v == "loanId"
                                                                ? "Loan ID"
                                                                : ws[address].v == "dlmName"
                                                                  ? "DLM Name"
                                                                  : ws[address].v == "tillNumber"
                                                                    ? "Till Number"
                                                                    : ws[address].v;
          }
        }

        const wb = {
          Sheets: { data: ws },
          SheetNames: [`data`],
        };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const fileData = new Blob([excelBuffer], { type: fileType });
        fileSaver.saveAs(fileData, fileName + fileExtension);
      };

      // Example usage:
      const columnsToKeep = [
        "distributor",
        "distCenter",
        "vizShopCode",
        "distShopCode",
        "shopName",
        "cnicNo",
        "mobileNumber",
        "financier",
        "invoiceNumber",
        "invoiceAmount",
        "financeAmount",
        "repaidAmount",
        "outstandingAmount",
        "paidThrough",
        "financeStatus",
        "invoiceDateStr",
        "financeId",
        "financeDateStr",
        "profitAmount",
        "totalPayable",
        "repaymentDateStr",
        "tid",
        "tillNo",
        "distShopName",
        "loanId",
        "dlmName",
        "tillNumber"
      ];

      exportToCSV(data?.report, "", outputFilename, columnsToKeep);
      dispatch(hideLoading());
    })

    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      }
    });
};
